<template>
  <div class="qb-card">
    <slot />
  </div>
</template>

<script>
export default {
  name: "CardComponent",
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/color.scss";
@import "../assets/scss/font.scss";
@import "../assets/scss/field.scss";

.qb-card {
  background-color: $white;
  border-radius: $field-border-radius;
  border: 2px solid $border-color;
  box-shadow: 0 4px 12px #0420400d;
}
</style>
